import React from 'react';
import { Box } from '@mui/material';

export function CitizenNameHighlight({ preferredName, fullName }: { preferredName?: string; fullName: string }) {
  const trimmedPreferredName = preferredName?.trim();

  if (!trimmedPreferredName) {
    return <>{fullName}</>;
  }

  if (trimmedPreferredName.toLowerCase() === fullName.trim().toLowerCase()) {
    return (
      <Box component="span" sx={{ textDecoration: 'underline', fontWeight: 'inherit' }}>
        {fullName}
      </Box>
    );
  }

  return (
    <>
      <Box component="span" sx={{ textDecoration: 'underline', fontWeight: 'inherit' }}>
        {trimmedPreferredName}
      </Box>{' '}
      {fullName}
    </>
  );
}
